export default {
    Page: 1,
    Resource: 2
}
